import React, { memo, forwardRef } from "react";
const SvgXi = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18.967 27.632c-.694 0-1.149-.733-.882-1.373l.067-.163c.208-.496.312-.968.312-1.416 0-.24-.04-.456-.12-.648-.08-.192-.264-.376-.552-.552-.272-.16-.728-.304-1.368-.432-1.168-.256-2.16-.584-2.976-.984-.8-.4-1.408-.92-1.824-1.56-.416-.656-.624-1.48-.624-2.472 0-.864.16-1.616.48-2.256.32-.64.752-1.168 1.296-1.584a5.098 5.098 0 011.824-.888v-.144c-.608-.16-1.12-.384-1.536-.672a2.889 2.889 0 01-.936-1.128c-.208-.448-.312-.976-.312-1.584 0-.752.16-1.368.48-1.848a3.883 3.883 0 011.296-1.2 7.94 7.94 0 011.776-.72c-.192.016-.448.04-.768.072-.32.016-.664.032-1.032.048s-.736.024-1.104.024a.744.744 0 01-.744-.744v-.06c0-.444.36-.804.804-.804h7.38c.41 0 .744.333.744.744v.12c0 .345-.28.624-.624.624-.832 0-1.624.056-2.376.168a7.087 7.087 0 00-1.968.576c-.56.272-1.008.64-1.344 1.104-.32.464-.48 1.04-.48 1.728 0 .544.128 1.024.384 1.44.256.416.672.744 1.248.984s1.336.36 2.28.36h1.788a.804.804 0 010 1.608h-1.86c-1.12 0-2.016.176-2.688.528-.656.336-1.128.784-1.416 1.344a4.032 4.032 0 00-.432 1.872c0 .752.144 1.344.432 1.776.288.432.752.776 1.392 1.032.64.256 1.48.512 2.52.768.848.192 1.488.424 1.92.696.448.272.752.584.912.936.16.352.24.744.24 1.176 0 .464-.048.888-.144 1.272-.08.4-.2.776-.36 1.128-.087.19-.178.386-.274.586a.92.92 0 01-.831.518z"
      />
    </svg>
  );
});
SvgXi.displayName = "SvgXi";
const MemoForwardRef = memo(SvgXi);
export default MemoForwardRef;
